import { useForm, Controller } from "react-hook-form";
import Filter from "./Filter"
import { Autocomplete, Box, TextField } from "@mui/material";
import { IMaskInput } from "react-imask";
export const FilterOwner = ({ onFilter, pets = [] }) => {

    const defaultValues = {
        name: "",
        email: "",
        document: "",
        pet_id: "",
    }

    const methods = useForm({ defaultValues });

    return (
        <Filter onFilter={methods.handleSubmit(onFilter)} onClear={() => methods.reset(defaultValues)}>
            <Box display='flex' flexDirection='column' className='gap-1'>
                <TextField
                    id="name"
                    label="Nome"
                    variant="outlined"
                    name="name"
                    {...methods.register("name")}
                />
                <TextField
                    id="email"
                    label="Email"
                    variant="outlined"
                    name="email"
                    {...methods.register("email")}
                />
                <TextField
                    id="document"
                    label="Documento"
                    variant="outlined"
                    name="document"
                    InputProps={{
                        inputComponent: IMaskInput,
                    }}
                    inputProps={{
                        mask: "000.000.000-00"
                    }}
                    {...methods.register("document")}
                />

                <Controller
                    name="pet_id"
                    control={methods.control}
                    render={({ field }) => {
                        const petOptions = pets.map(pet => ({
                            label: pet.name,
                            value: pet.id
                        }));
                        const selectedPet = petOptions.find(option => option.value === field.value);
                        
                        return (
                            <Autocomplete
                                value={selectedPet || null}
                                options={petOptions}
                                getOptionLabel={(option) => option.label || ''}
                                isOptionEqualToValue={(option, value) => option.value === value?.value}
                                onChange={(_, data) => field.onChange(data?.value || '')}
                                renderInput={(params) => <TextField {...params} label="Pet" />}
                            />
                        );
                    }}
                />
            </Box>
        </Filter>

    )
}